import { createContext, use } from 'react';

export const NonceContext = createContext<string | undefined>(undefined);

export const useServerOnlyNonce = () => {
  if (import.meta.env.DEV) return undefined;

  const nonce = use(NonceContext);

  // The default value (undefined) will be used on the client render
  return nonce;
};
